var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M14.919 2.317h-9.84a2.489 2.489 0 0 0-2.485 2.487v9.245a2.49 2.49 0 0 0 1.985 2.436v.698a.5.5 0 1 0 1 0v-.648h8.84v.648a.5.5 0 1 0 1 0v-.698a2.49 2.49 0 0 0 1.986-2.436V4.804a2.489 2.489 0 0 0-2.486-2.487Zm1.487 11.732a1.488 1.488 0 0 1-1.487 1.486h-9.84a1.488 1.488 0 0 1-1.486-1.486V4.804A1.488 1.488 0 0 1 5.08 3.318h9.84a1.488 1.488 0 0 1 1.487 1.486v9.245Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M12.895 8.926H12.3a2.338 2.338 0 0 0-.322-.77l.424-.424a.5.5 0 1 0-.707-.707l-.424.423a2.334 2.334 0 0 0-.77-.322V6.53a.5.5 0 1 0-1 0v.596c-.274.06-.535.17-.771.322l-.424-.423a.5.5 0 1 0-.706.707l.423.423a2.338 2.338 0 0 0-.322.771h-.596a.5.5 0 0 0 0 1H7.7c.06.274.17.535.322.77l-.424.424a.5.5 0 1 0 .707.707l.423-.423c.236.153.498.262.772.322v.596a.5.5 0 1 0 1 0v-.596c.274-.06.535-.17.77-.322l.424.423a.498.498 0 0 0 .827-.155.5.5 0 0 0-.12-.552l-.424-.423c.153-.236.262-.497.322-.77h.596a.5.5 0 1 0 0-1ZM10 10.782a1.356 1.356 0 1 1 0-2.712 1.356 1.356 0 0 1 0 2.712Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgDark);
export default __webpack_public_path__ + "static/media/org-dark.f9ea1d69db9b68965431fd76c8475864.svg";
export { ForwardRef as ReactComponent };